var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 374.156,
    height: 346.802,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2956.89 2740.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#fefefe}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2513101745824"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.14 1482.55h61.13c60.09 0 109.26 49.16 109.26 109.25v1053.93c0 52.24-42.74 94.98-94.98 94.98h-75.4c-93.71 0-170.39-76.67-170.39-170.39v-917.39c0-93.71 76.67-170.39 170.39-170.39zM2447.33 1482.55h-61.13c-60.09 0-109.26 49.16-109.26 109.25v1053.93c0 52.24 42.74 94.98 94.98 94.98h75.4c93.71 0 170.39-76.67 170.39-170.39v-917.39c0-93.71-76.67-170.39-170.39-170.39z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.14 1482.55h61.13c60.09 0 109.26 49.16 109.26 109.25v1053.93c0 52.24-42.74 94.98-94.98 94.98h-75.4c-93.71 0-170.39-76.67-170.39-170.39v-917.39c0-93.71 76.67-170.39 170.39-170.39z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 224.48,
    height: 934.13,
    y: 1644.57,
    className: "fil0",
    rx: 112.24,
    ry: 123.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2447.33 1482.55h-61.13c-60.09 0-109.26 49.16-109.26 109.25v1053.93c0 52.24 42.74 94.98 94.98 94.98h75.4c93.71 0 170.39-76.67 170.39-170.39v-917.39c0-93.71-76.67-170.39-170.39-170.39z",
    className: "fil0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 224.48,
    height: 934.13,
    x: 2732.4,
    y: 1644.57,
    className: "fil0",
    rx: 112.24,
    ry: 123.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89 1448.15c0-715.75 585.61-1301.36 1301.37-1301.36 715.75 0 1301.36 585.61 1301.36 1301.36v104.49h116.03v-121.6C2902.65 643.97 2258.69.01 1471.61.01 684.54.01 40.58 643.97 40.58 1431.04v121.6h143.31z",
    className: "fil0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsIcon);
export default __webpack_public_path__ + "static/media/tickets-icon.668859dff907285a4e1422ee321cbec4.svg";
export { ForwardRef as ReactComponent };